
import { useState, useCallback } from 'react';
import CheckoutNavbar from './components/CheckoutNavbar';
import RequestCheckoutList from './components/RequestCheckoutList';
import Loading from './../../Loading';
import { GET_lastes_Withdrawals } from './../../../api/api';
import InfiniteScroll from 'react-infinite-scroller';
import axios from 'axios';

const CheckoutRequest = () => {

     const [item, setItem] = useState([])

     const [notFound, setNotFound] = useState(false)
     const [isError, setIsError] = useState(false)

     const [pageNum, setPageNum] = useState(1)
     const [fetching, setFetching] = useState(false)


     //loadmore

     const fetchItems = useCallback(
          async () => {
               if (fetching || isError) {
                    return;
               }

               setFetching(true);

               try {
                    const res = await axios.get(GET_lastes_Withdrawals(pageNum))
                    setItem([...item, ...res.data])
                    res.data != '' ? setPageNum(pageNum + 1) : setPageNum(null)
                    res.data == '' && pageNum === 1 ? setNotFound(true) : setNotFound(false)
               } catch (err) {
                    setIsError(true)

               } finally {
                    setFetching(false)

               }

          },


          [item, fetching, pageNum]
     );

     const hasMoreItems = !!pageNum;
     //loadmore

     return (
          <>
               <CheckoutNavbar />

               <div className="contentHolder">
                    <InfiniteScroll loadMore={fetchItems} hasMore={hasMoreItems} loader={<Loading key={pageNum} styles={'mini'} />}>
                         <RequestCheckoutList data={item} />
                    </InfiniteScroll>
               </div>

               {notFound ? (<p style={{ textAlign: 'center' }}>هیچ داده ای برای نمایش وجود ندارد!</p>) : ''}
          </>
     )
}

export default CheckoutRequest